import ShippingBand from "./shippingBand";

export default ShippingBand;
